export default __webpack_public_path__ + "static/media/type-wrong.132a8b19.png";